import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, Typography, Container, Paper, Button, CircularProgress } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import AppNav from '../../components/appNav';

export default function CheckoutSuccess() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(true);
    const [paymentInfo, setPaymentInfo] = useState(null);

    useEffect(() => {
        // Captura parâmetros da URL retornados pela Asaas
        const externalReference = searchParams.get('externalReference');
        const paymentId = searchParams.get('id');
        const status = searchParams.get('status');

        if (externalReference || paymentId) {
            setPaymentInfo({
                externalReference,
                paymentId,
                status
            });
        }
        
        setLoading(false);
    }, [searchParams]);

    const handleBackToEvents = () => {
        navigate('/');
    };

    return (
        <>
            <AppNav />
            <Container maxWidth="md" sx={{ mt: 8, mb: 4 }}>
                <Paper 
                    elevation={3} 
                    sx={{ 
                        p: 4, 
                        textAlign: 'center',
                        borderRadius: 2
                    }}
                >
                    {loading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <>
                            <CheckCircleOutlineIcon 
                                sx={{ 
                                    fontSize: 80, 
                                    color: 'success.main',
                                    mb: 2 
                                }} 
                            />
                            
                            <Typography 
                                variant="h4" 
                                component="h1" 
                                gutterBottom
                                sx={{ fontWeight: 'bold', color: 'success.main' }}
                            >
                                Pagamento Confirmado!
                            </Typography>

                            <Typography 
                                variant="body1" 
                                color="text.secondary" 
                                sx={{ mb: 3 }}
                            >
                                Sua inscrição foi processada com sucesso.
                            </Typography>

                            {paymentInfo && (
                                <Box 
                                    sx={{ 
                                        mt: 3, 
                                        p: 2, 
                                        bgcolor: 'grey.100', 
                                        borderRadius: 1,
                                        textAlign: 'left'
                                    }}
                                >
                                    <Typography variant="body2" gutterBottom>
                                        <strong>Detalhes da Transação:</strong>
                                    </Typography>
                                    
                                    {paymentInfo.externalReference && (
                                        <Typography variant="body2" color="text.secondary">
                                            Código: {paymentInfo.externalReference}
                                        </Typography>
                                    )}
                                    
                                    {paymentInfo.paymentId && (
                                        <Typography variant="body2" color="text.secondary">
                                            ID Pagamento: {paymentInfo.paymentId}
                                        </Typography>
                                    )}
                                </Box>
                            )}

                            <Typography 
                                variant="body2" 
                                color="text.secondary" 
                                sx={{ mt: 3, mb: 3 }}
                            >
                                Um e-mail de confirmação foi enviado com os detalhes da sua inscrição.
                            </Typography>

                            <Button 
                                variant="contained" 
                                color="primary" 
                                size="large"
                                onClick={handleBackToEvents}
                                sx={{ mt: 2 }}
                            >
                                Voltar para Eventos
                            </Button>
                        </>
                    )}
                </Paper>
            </Container>
        </>
    );
}
